import { CompletedEPTourResponse, CompletedEPTourPagination } from './types';

export const mapGetCompletedEPToursResponseToSetCompletedEPToursPayload = (
  response: CompletedEPTourResponse
): CompletedEPTourPagination => {
  if (response.status === 204) {
    return {
      content: [],
      currentPage: 0,
      totalPages: 0,
    };
  }

  const { ordersByType = {}, currentPage = 0, totalPages = 0 } = response.data || {};
  const { pickTours = [] } = ordersByType?.COMMERCIALEP || {};
  return <CompletedEPTourPagination>{
    content: pickTours,
    currentPage,
    totalPages,
  };
};
